import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import AppButton from '../../Components/MerchantButton';
import { compressAndUpload } from '../../Helpers/Utils/photoUpload';
import './UnifiedFormStyles.css';

const TroubleshootQRStickerPhoto = ({ navigation, primaryDetails, setPrimaryDetails }) => {
  const [error, setError] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleBack = () => {
    navigation.previous();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      setError('Photo exceeds 5MB limit. Please retake the photo.');
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    setError('');
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        setError('Upload failed. Please try again.');
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        qr_sticker_distribution_photo_temp_path: uploadResult.temp_path
      }));
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!primaryDetails.qr_sticker_distribution_photo_temp_path) {
      setError('Photo is required');
      toast.error('Please attach a QR sticker photo before continuing', { autoClose: 2500, hideProgressBar: true, theme: 'colored' });
      return;
    }
    if (navigation && navigation.go) navigation.go('troubleshoot-p1-sticker');
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Troubleshoot QR Sticker Photo</h4>
              <p className="form-desc">Upload TROUBLESHOOT QR Sticker photo.</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Photo of QR Sticker <span className="form-required">*</span>
                      {primaryDetails.qr_sticker_distribution_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      isInvalid={!!error}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                    {error && <div className="form-error">{error}</div>}
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton type="button" onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton type="button" onClick={handleNext} variant="next" className="form-btn variant-primary">
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TroubleshootQRStickerPhoto;

